import { useSyncExternalStore } from 'react';

const never = () => () => {};

/**
 * Whether the browser has taken over the page. `false` on the server and for the one render in
 * which the browser adopts the server's markup — that render has to produce the very same markup —
 * and `true` from then on, before anything is painted again.
 *
 * It is the gate for whatever only the browser knows: the visitor's clock, what is in
 * `localStorage`, whether Telegram is around the page. A component reads those behind it, so the
 * server and the first render agree and the visitor's own answer follows at once.
 */
export const useHydrated = (): boolean =>
  useSyncExternalStore(
    never,
    () => true,
    () => false
  );
